export const setI18nLanguage = (language) => {
	return {
		type: 'SET_I18N_LANGUAGE',
		language
	};
};

export const setI18nLanguages = (languages) => {
	return {
		type: 'SET_I18N_LANGUAGES',
		languages
	};
};

export const setI18nContent = (content) => {
	return {
		type: 'SET_I18N_CONTENT',
		content
	};
};
